import styled, { css } from 'styled-components'
import TimesWhiteIcon from '../../../images/icon_times_white.svg'
import { themeStyles } from '../../../styles/theme'

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 0 26px 1rem 26px;
  padding-top: ${({ isMobile }) => (isMobile ? '22px' : '57px')};
`

export const customHeaderStyles = css`
  background: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};

  button {
    background-image: url('${TimesWhiteIcon}');
    top: 50%;
    right: 18px;
  }
`

export const StyledDrawerWrapper = styled.div`
  z-index: 489;
  position: relative;
`
